import React, { Component } from 'react'
import PropTypes from 'prop-types'

import DeliverySection from './../block/DeliverySection'
import CatalogSection from './../block/CatalogSection'
import RecommendedSection from './../block/RecommendedSection'
import PromotionsSection from './../block/PromotionsSection'
import LegalProductsOnMain from './../block/LegalProductsOnMain'
import AkciiSlyder from './../block/AkciiSlyder'
import AboutCompanySection from './../block/AboutCompanySection'
import WhyTrustUsSection from './../block/WhyTrustUsSection'
import PartnersSlyder from './../block/PartnersSlyder'
import TestimonialsSection from './../block/TestimonialsSection'
import FAQSection from './../block/FAQSection'

export default class Main extends Component {

  render() {

    const { data, ajax_data, changeFavorite, favorite, cart, addTocart, user_profile_type, authorized } = this.props

    return (
      <>
        <h1 className="visually-hidden">Компания StomaHelp</h1>
        <DeliverySection page_data={data?.page_data || {}} resource={ajax_data} user_profile_type={user_profile_type} />
        {user_profile_type == `individual` ?
          <>
            <CatalogSection items={data?.catalog || []} />
            <RecommendedSection
              page_data={data?.page_data || {}}
              products={ajax_data?.popular || []}
              changeFavorite={changeFavorite}
              favorite={favorite}
              cart={cart}
              addTocart={addTocart}
              user_profile_type={user_profile_type}
            />
            <PromotionsSection
              page_data={data?.page_data || {}}
              products={ajax_data?.favorite || []}
              changeFavorite={changeFavorite}
              favorite={favorite}
              cart={cart}
              addTocart={addTocart}
              user_profile_type={user_profile_type}
            />
          </>
        :
          <>
            <LegalProductsOnMain
              products={ajax_data?.ulcatalog || []}
              page_data={data?.page_data || {}}
            />
            <AkciiSlyder
              page_data={data?.page_data || {}}
              slydes={ajax_data?.akciislyder || []}
              hidetitle={false}
            />
          </>
        }
        <AboutCompanySection
          page_data={data?.page_data || {}}
          text={ajax_data?.text}
          text_legal={ajax_data?.text_legal}
          user_profile_type={user_profile_type}
        />
        <WhyTrustUsSection
          page_data={data?.page_data || {}}
          user_profile_type={user_profile_type}
        />
        {user_profile_type == `individual` &&
          <PartnersSlyder
            list={ajax_data?.partners || []}
          />
        }
        <TestimonialsSection
          page_data={data?.page_data || {}}
          feedback={ajax_data?.feedback_ng || []}
          feedback_legal={ajax_data?.feedback_ng_legal || []}
          user_profile_type={user_profile_type}
          mainpage={true}
        />
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
      </>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  changeFavorite: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  user_profile_type: PropTypes.string,
  authorized: PropTypes.bool
}